/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Startdatetimerequired3Inputs */

const en_startdatetimerequired3 = /** @type {(inputs: Startdatetimerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start date and time is required`)
};

const de_startdatetimerequired3 = /** @type {(inputs: Startdatetimerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum und -zeit ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Start date and time is required" |
*
* @param {Startdatetimerequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const startdatetimerequired3 = /** @type {((inputs?: Startdatetimerequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Startdatetimerequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_startdatetimerequired3(inputs)
	return de_startdatetimerequired3(inputs)
});
export { startdatetimerequired3 as "startDateTimeRequired" }